import React from 'react';

import { faSpinnerThird } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';

import { cn } from 'src/utils/shadcn';

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
    return (
        <div
            className={cn('animate-pulse rounded-md bg-gray-200 dark:bg-gray-800', className)}
            role="status"
            {...props}
        />
    );
}

function VideoSkeleton({ className, ...props }: Omit<FontAwesomeIconProps, 'icon'>) {
    return (
        <FontAwesomeIcon
            icon={faSpinnerThird}
            aria-hidden="true"
            focusable="false"
            className={cn('absolute scale-250 animate-spin text-white', className)}
            {...props}
        />
    );
}

export { Skeleton, VideoSkeleton };
